module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"type": "object",
	"properties": {
		"name": {
			"type": "string",
			"messages": {
				"type": "name must be a string",
				"required": "name is required"
			}
		}
	},
	"required": [
		"name"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/schemas/page.json
 ** module id = 5
 ** module chunks = 0
 **/